import { useContext } from 'react';
import { WorkspaceConfigContext } from '@r/context/workspace-config-context.ts';

/** Lit un booléen stocké en workspace config (type `core`, valeur `"true"` / `"false"`). */
export function useCoreWorkspaceConfigFlag(key: string): boolean {
  const workspaceConfigContext = useContext(WorkspaceConfigContext);
  const value = workspaceConfigContext?.groupedConfigs?.core?.[key];
  return value === 'true';
}
